export const SELECT_USER_FUNCTION_FOR_TRAININGS_FILTER =
    'SELECT_USER_FUNCTION_FOR_TRAININGS_FILTER';

export const selectUserFunctionForTrainingsFilter = (value) => {
    return {
        type: SELECT_USER_FUNCTION_FOR_TRAININGS_FILTER,
        payload: value,
    };
};
